module.exports = __webpack_public_path__ + "img/landing-2-cs-CZ.1401b52.png";